<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5595 5595"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="2797" cy="2797" r="2797"/>
  <path class="fil1" d="M3475 4689c101,0 174,-5 267,-41 130,-50 232,-122 317,-236 28,-37 57,-79 76,-123 71,-167 91,-326 32,-501 -57,-171 -156,-303 -260,-442l-302 -404c-40,-64 -52,-105 -104,-105 -43,0 -67,56 -96,103 -40,66 -215,296 -278,373 -108,132 -233,317 -284,472 -54,161 -44,304 13,463 31,88 116,208 186,266 77,65 130,96 222,133 13,5 26,9 38,13 43,14 119,29 173,29z"/>
  <rect class="fil1" x="1691" y="654" width="367" height="4087" rx="184" ry="184"/>
  <path class="fil1" d="M2046 1179l0 367 244 0c101,0 184,-83 184,-183l0 -1c0,-100 -83,-183 -184,-183l-244 0z"/>
  <path class="fil1" d="M2046 1897l0 367 244 0c101,0 184,-82 184,-183l0 0c0,-101 -83,-184 -184,-184l-244 0z"/>
  <path class="fil1" d="M2046 2611l0 367 244 0c101,0 184,-82 184,-183l0 0c0,-101 -83,-184 -184,-184l-244 0z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'WaterLevelMeasurement',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#56D6D1}
</style>
